import React, { useMemo } from 'react';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  commonPCConsoleDefaultFilterValue,
  handleDetailConsoleDataFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import {
  CONSOLE_DATA_PLATFORM_CASCADER_DEFAULT,
  getAlineaPlatformsCascaderOptions,
} from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import { createPlatformCascaderDisplayRenderConfig } from '@intelligence/_config/components/filters/platformCascaderDisplayRender';
import ConsoleDataView from './ConsoleDataView';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';

export default function ConsoleData(props: any) {
  const hidePlatformFilter =
    props?.subSegment === 'alinea__ps_est_revenue';
  const defaultFilterValue = useMemo(
    () => ({
      ...commonPCConsoleDefaultFilterValue,
      [filterKeyMap.PLATFORMCASCADER]: {
        value: CONSOLE_DATA_PLATFORM_CASCADER_DEFAULT,
      },
    }),
    [],
  );

  const platformCascaderOptions = useMemo(
    () =>
      getAlineaPlatformsCascaderOptions(
        CONSOLE_DATA_PLATFORM_CASCADER_DEFAULT,
        createPlatformCascaderDisplayRenderConfig({ fullCheckGroupCount: 1 }),
      ),
    [],
  );

  const filterCfg: TopchartFilterCfgType = useMemo(
    () => ({
      filterKeyList: hidePlatformFilter
        ? [filterKeyMap.RANGE_TIME]
        : [filterKeyMap.RANGE_TIME, filterKeyMap.PLATFORMCASCADER],
      regionFilterParams: {},
      defaultValue: defaultFilterValue,
      resetFilterValue: {
        ...defaultFilterValue,
      },
      specialParams: {
        rangeTimeType: FilterTimeType.commonRange,
        showSelectType: true,
        typeList: ['date', 'week', 'month'],
        isShowAlloftime: false,
        platformCascaderOptions,
      },
      showConfirmButton: false,
      haveFilterSaveBtn: false,
      handleFilterToApiParams: handleDetailConsoleDataFilterParamsToApi,
    }),
    [defaultFilterValue, hidePlatformFilter, platformCascaderOptions],
  );

  return <ConsoleDataView {...props} filterCfg={filterCfg} />;
}
